import { render } from "./CallLastWeekTabCont.vue?vue&type=template&id=13195837"
import script from "./CallLastWeekTabCont.vue?vue&type=script&lang=js"
export * from "./CallLastWeekTabCont.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__